module.exports = __webpack_public_path__ + "img/serviceDetail3.0b6212d6.png";